import router from "@/Routes";
import store from './store'
import Vue from 'vue'
import {
    customer,
    product,
    pricelist,
    // discountcoupon,
    amcservice,
    retainerinvoice,
    quotation,
    invoice,
    amccontract,
    recurringinvoice,
    paymentsreceived,
    customeradvance,
    creditnote,
    gstfiling,
    reports,
    permissionRoutes,
    settingsPage,
    settingsRoutes,
    dashboard,
    banking,
    errorRoutes
} from "@/Routes";
/**
 * nprogress bar
 */
// import NProgress from "nprogress";

import getPageTitle from "@/utils/get-page-title";

const whiteList = ['/404', '/index', '/']; // no redirect whitelist
const permissionDenied = []; // redirect to permission denied page
router.beforeEach(async (routeTo, routeFrom, next) => {
    // Start the route progress bar.
    // NProgress.start();
    store.state.layout.isLoading = true;
    //  page title from router
    document.title = getPageTitle(routeTo.meta.title)
    //  check for an refresh
    if(routeFrom.matched[0]&&routeFrom.matched[0].path != '/settings'&&routeFrom.matched[0].path !=''&&routeFrom.matched[0].path !='index'){
        store.state.general.module_path = routeFrom.fullPath ;
    }else{
        store.state.general.module_path = store.state.general.module_path?store.state.general.module_path:'/app/'
    }
    if ((window.meta == '' || typeof window.meta == 'undefined') && whiteList.indexOf(routeTo.path) == -1) {
        next(`/?redirect=${routeTo.fullPath}`)

    } else {
        const hasallowed = Object.entries(store.getters.isallowedroutes).length > 0;
        if (hasallowed) {
            if (permissionDenied.indexOf(routeTo.name) !== -1) {
                next('/500');
            } else {
                next();
            }
        } else {
            if (typeof window.meta != "undefined" && window.meta != '') {

                const {
                    isallowedroutes,
                    role_name,
                    general_settings_details
                } = await store.dispatch('permission/generateRoutes', JSON.stringify({
                    app_id: process.env.VUE_APP_APP_ID,
                    org_id: Vue.prototype.$AppDetails.organization.org_id
                }));
                //  hiding tax menu for gst unregistered customer
                if (Vue.prototype.$AppDetails.organization.gst_type == 3) {
                    settingsPage[22].meta.affix = false
                    permissionDenied.push(settingsPage[22].name)
                }

                //  add all the routes dynamically
                const routes = permissionRoutes["children"].concat(dashboard,
                    customer,
                    banking,
                    product,
                    pricelist,
                    // discountcoupon,
                    amcservice,
                    quotation,
                    retainerinvoice,
                    invoice,
                    amccontract,
                    recurringinvoice,
                    paymentsreceived,
                    customeradvance,
                    creditnote,
                    gstfiling,
                    reports);
                // const routes = permissionRoutes["children"].concat(dashboard, customer);
                const settingsroutes = settingsRoutes["children"].concat(settingsPage);



                if (role_name == 'admin') {
                    //  push the added routes
                    await routes.forEach(route => {
                        //  check for an selected module
                        if (typeof general_settings_details.preferences.modules[route.name] != 'undefined' && general_settings_details.preferences.modules[route.name] == false) {
                            route.meta.affix = false
                        }
                        if (Vue.prototype.$AppDetails.organization.gst_type == 3) {
                            var path = route.path.split("/")
                            if (path[0] == 'customeradvance' || path[0] == "tax") {
                                route.meta.affix = false
                                permissionDenied.push(route.name)
                            }
                        }
                    });
                    permissionRoutes["children"] = routes;
                    settingsRoutes["children"] = settingsroutes;
                } else {
                    var allowed_routes = []
                    var allowed_settings_routes = []
                    await routes.forEach(route => {
                        //  check for an selected module
                        if (typeof general_settings_details.preferences.modules[route.name] != 'undefined' && general_settings_details.preferences.modules[route.name] == false) {
                            route.meta.affix = false
                        }
                        //  check for action present in the role details and page
                        var path = route.path.split("/")
                        if (Vue.prototype.$AppDetails.organization.gst_type == 3 && (path[0] == 'customeradvance' || path[0] == "tax")) {
                            route.meta.affix = false
                            permissionDenied.push(route.name)
                        } else if (route.meta.role == 'public' || route.meta.hasChildren == true) {
                            //  if it is public page give access to all 
                            allowed_routes.push(route)
                        } else if (
                            (typeof isallowedroutes[route.meta.page] != 'undefined') && typeof isallowedroutes[route.meta.page][route.meta.action] != 'undefined'
                        ) {
                            /**
                             *  invoice routes  
                             * */
                            if (isallowedroutes[route.meta.page][route.meta.action] == true) {
                                allowed_routes.push(route)
                            } else {
                                permissionDenied.push(route.name)
                            }
                        } else {
                            permissionDenied.push(route.name)
                        }
                    });
                    //  push the added routes
                    permissionRoutes["children"] = allowed_routes;

                    //  settings page routes
                    await settingsroutes.forEach(route => {
                        //  check for action present in the role details and page
                        if (
                            (typeof route.meta != 'undefined' && typeof isallowedroutes[route.meta.page] != 'undefined') && typeof isallowedroutes[route.meta.page][route.meta.action] != 'undefined'
                        ) {
                            if (isallowedroutes[route.meta.page][route.meta.action] == true) {
                                allowed_settings_routes.push(route)
                            } else {
                                permissionDenied.push(route.name)
                            }
                        } else if (route.meta.role == 'public') {
                            //  if it is public page give access to all 
                            allowed_settings_routes.push(route)
                        }
                    });
                    //  push the added routes
                    settingsRoutes["children"] = allowed_settings_routes;
                }
                Vue.prototype.$permissionDenied = permissionDenied
                //  add the routes to the router 
                await router.addRoutes([permissionRoutes])
                //  add settings routes
                await router.addRoutes([settingsRoutes])
                //  finally add the 404 page error route
                await router.addRoutes([errorRoutes])

                //  replace true to check the added routes
                next({
                    ...routeTo,
                    replace: true
                })
            } else {
                next();
            }
        }
    }
});
router.afterEach(() => {
    // Complete the animation of the route progress bar.
    // NProgress.done();

    store.state.layout.isLoading = false;

});